/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  instance_id: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  instance_name: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  public_ip: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
